import { useState } from 'react';
import { Button } from 'antd';
import { CloseOutlined, MessageOutlined } from '@ant-design/icons';

export const ClosableTextComponent = ({ text, onClose }) => {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'relative',
      backgroundColor: 'rgb(0, 115, 187)',
      marginRight: '60px'
    }}>
      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={handleClose}
        style={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'white'
        }}
      />
      <div style={{ padding: '0 24px 0', color: 'white' }}>
        {/* <div>{" Update request is process\n"}</div> */}
        <div style={{textAlign: 'left', fontSize: '13px'}}><MessageOutlined/>{" Your account setup is in progress. Our team is reviewing your request and will finalize everything shortly. We’ll notify you once it’s complete. Thanks for your patience."}</div>
      </div>
    </div>
  );
};